import { categories } from "entities/customerTickets/constants";
import {
  FilterKeys,
  FilterOptions,
  TicketStatus,
} from "entities/customerTickets/types";
import { LocaleCode } from "shared/types/languages";
import { Filters } from "../types";

export const ticketStatuses = [
  { value: TicketStatus.Open, label: "Open" },
  { value: TicketStatus.Processing, label: "Processing" },
  { value: TicketStatus.Answered, label: "Answered" },
  { value: TicketStatus.Closed, label: "Closed" },
];

export const languages = [
  { value: LocaleCode.ja, label: "Japanese" },
  { value: LocaleCode.en, label: "English" },
];

export const products = [
  { value: "International", label: "International" },
  { value: "Telegram", label: "Telegram" },
];

export const categoryOptions = [
  ...categories.map((cat) => ({ value: cat.key, label: cat.key })),
];

export const subCategories = [
  ...categories.flatMap((category) =>
    category.subCategories
      ? category.subCategories.map((sub) => ({
          value: sub.key,
          label: sub.key,
        }))
      : [],
  ),
];

export const reads = [{ value: "unread", label: "Unread" }];

export const filterConfigs = [
  { key: "status", options: ticketStatuses, label: "Status" },
  { key: "language", options: languages, label: "Language" },
  { key: "product", options: products, label: "Product" },
  {
    key: "category.key",
    options: categoryOptions,
    label: "Category",
  },
  {
    key: "subCategory.key",
    options: subCategories,
    label: "Subcategory",
  },
  { key: "read", options: reads, label: "Visibility" },
];

export const getFilteredValues = (
  options: { value: string }[],
  excludeAll: boolean = true,
): string[] => {
  return options
    .filter((option) => !excludeAll || option.value !== FilterOptions.all)
    .map((option) => option.value);
};

export const getAllFilterValues = (key: string): string[] => {
  const optionMappings: {
    [key: string]: { data: { value: string }[]; excludeAll?: boolean };
  } = {
    status: { data: ticketStatuses },
    language: { data: languages },
    product: { data: products },
    "category.key": { data: categoryOptions, excludeAll: false },
    "subCategory.key": { data: subCategories },
    read: { data: reads },
  };
  const option = optionMappings[key];
  return option ? getFilteredValues(option.data, option.excludeAll) : [];
};

export const createFilterString = (key: string, values: string[]): string => {
  const isAll = values.includes(FilterOptions.all);
  if (isAll) {
    const allFilterValues = getAllFilterValues(key);
    return `(${allFilterValues.map((value) => `${key}:"${value}"`).join(" OR ")})`;
  }

  return values.length > 0
    ? `(${values.map((value) => `${key}:"${value}"`).join(" OR ")})`
    : "";
};

export const createReadFilterString = (values: string[]): string => {
  const isAll = values[0]?.includes(FilterOptions.all);
  const isUnread = values[0]?.includes("unread");
  if (isAll) return "";
  if (isUnread) return "adminUnreadMessagesCount>0";
  return "";
};

export const formattedFilters = (filteredValues: Filters) => {
  const filterStrings = Object.keys(filteredValues).map((key) => {
    if (key === FilterKeys.read) {
      return createReadFilterString(filteredValues[key]);
    }
    return createFilterString(key, filteredValues[key]);
  });

  return filterStrings.filter(Boolean).join(" AND ");
};
